import { createLiveStore, useRpc } from "../lib/live-store";
import { apiClient } from "../lib/api-client";
import type { QueueItem, QueueStatusCounts } from "../types/api";

interface QueueStatusData {
  counts: QueueStatusCounts | null;
}

export const useQueueStatusStore = createLiveStore<QueueStatusData>({
  topic: "queue.status",
  onSnapshot: (data) => ({ counts: data as QueueStatusCounts }),
  state: () => ({ counts: null }),
});

interface QueueItemsData {
  items: QueueItem[];
}

interface QueueItemsExtra {
  statusFilter: string | undefined;
  setStatusFilter: (status: string | undefined) => void;
}

export const useQueueItemsStore = createLiveStore<QueueItemsData, QueueItemsExtra>({
  topic: "queue.items",
  params: (s) => (s.statusFilter ? { status: s.statusFilter } : undefined),
  onSnapshot: (data) => ({ items: data as QueueItem[] }),
  onEvent: () => null,
  state: (set) => ({
    items: [],
    statusFilter: undefined,
    setStatusFilter: (status: string | undefined) => set({ statusFilter: status } as any),
  }),
});

export function useUploadToQueue() {
  const mutate = async (data: { files: File[]; batchId: string }) => {
    const formData = new FormData();
    formData.append("batchId", data.batchId);
    for (const file of data.files) formData.append("images", file);
    return apiClient.upload<{ asset: any; queueItem: QueueItem }>("/queue/upload", formData);
  };
  return { mutate, mutateAsync: mutate };
}

export function useSubmitQueueAnswers() {
  return useRpc("queue.submitAnswers");
}

export function useSkipQueueItem() {
  return useRpc("queue.skip");
}

export function useRetryQueueItem() {
  return useRpc("queue.retry");
}

export function useDeleteQueueItem() {
  return useRpc("queue.delete");
}
